import {
  SET_SELECTED_LOAD_INTERESTS,
  GET_LOADS_INTERESTS_COUNT,
  GET_LOADS_INTERESTS,
  GET_LOAD_INTERESTS_CARRIER_REP_LIST,
  GET_LOADS_INTERESTS_DETAILS,
  UPDATE_USER_INTEREST,
  GET_LOAD_INTERESTS_STATES_LIST,
  GET_USER_BID_LOADS,
  GET_TRUCKBOOK_HAULS_COUNT,
  GET_OWNER_OPERATOR_CARRIER,
  GET_USER_INTERESTS_BIDS
} from 'redux/actions/UserInterests';

const INIT_STATE = {
  lastEvaluatedKey: 0,
  totalLoads: 0,
  isLoadsEnded: false,
  loads: [],
  userOtherLoads: {totalLoads: 0, loads: []},
  userBids: [],
  totalTruckBookHauls: 0,
  userCarrier: {},
  isLoading: false,
  selectedLoad: {},
  loadInterests: { total_count: 0, users: [] },
  loadsCount: {},
  carrierRepList: [],
  originStateList: [],
  destinationStateList: [],
  isLoadInterestsAccepted: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case SET_SELECTED_LOAD_INTERESTS: {
      return {
        ...state,
        selectedLoad: action.payload,
      };
    }

    case GET_LOADS_INTERESTS_COUNT: {
      return {
        ...state,
        loadsCount: action.payload,
      };
    }

    case GET_LOADS_INTERESTS_DETAILS: {
      const confirmedUsers = action.payload?.users?.filter((u)=> u?.status === 'Confirmed') || [];
      return {
        ...state,
        loadInterests: action.payload,
        isLoadInterestsAccepted: !!confirmedUsers.length ,
      };
    }

    case UPDATE_USER_INTEREST: {
      const users = [...state.loadInterests.users];
      let user = users.find(ui => ui.id === action.payload.id);
      if(action.payload.comments) {
        user.comments = action.payload.comments;
      }
      if(action.payload.status){
        user.status = action.payload.status;
      }
      const confirmedUsers = users.filter((u)=> u?.status === 'Confirmed') || [];
      return {
        ...state,
        loadInterests: { ...state.loadInterests, users},
        isLoadInterestsAccepted: !!confirmedUsers.length ,
      };
    }

    case GET_LOADS_INTERESTS: {
      const loads = action.isAppend ? [...state.loads, ...action.payload] : action.payload;
      return {
        ...state,
        loads: loads,
        lastEvaluatedKey: loads.length,
        totalLoads: action.totalLoads,
        isLoadsEnded: action.isLoadsEnded,
      };
    }
    case GET_LOAD_INTERESTS_CARRIER_REP_LIST: {
      return {
        ...state,
        carrierRepList: action.payload,
      };
    }

    case GET_USER_INTERESTS_BIDS: {
      return {
        ...state,
        userBids: action.payload,
      };
    }

    case GET_LOAD_INTERESTS_STATES_LIST: {
      return {
        ...state,
        originStateList: action.payload.originStateList || [],
        destinationStateList: action.payload.destinationStateList || [],
      };
    }

    case GET_USER_BID_LOADS: {
      return {
        ...state,
        userOtherLoads: {loads: action.payload, totalLoads: action.totalLoads},
      };
    }

    case GET_TRUCKBOOK_HAULS_COUNT: {
      return {
        ...state,
        totalTruckBookHauls: action.payload,
      };
    }

    case GET_OWNER_OPERATOR_CARRIER: {
      return {
        ...state,
        userCarrier: action.payload,
      };
    }

    default:
      return state;
  }
};
